<template>
    <LayoutDashboard title="Vendas">
       <ListarVendaCard botaoVisualizarVenda="true" />
    </LayoutDashboard>
</template>
<script>
    import ListarVendaCard from '@/pages/venda/ListarVendaCard'
    export default {
        components: {
            ListarVendaCard
        },
    }
</script>